import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./Item.local.scss";
import TTPModal from "../Common/Modal/TTPModal";
import { setDashboardSelectedItem } from "actions";

import _ from "i18n";
import CheckBox from "./CheckBox";
import { Button } from "antd";
import DashboardListFetching from "./DashboardListFetching";

// const { confirm } = Modal;

class DashboardActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAssociationModal: false,
      dashboardId: null,
      disabled: true
    };
  }

  handleSelectAllDashboard = () => {
    let { selectedDashboards, dashboardsList } = this.props;
    if (selectedDashboards.length === dashboardsList.length) {
      selectedDashboards = [];
    } else {
      selectedDashboards = dashboardsList.map(dashboard => dashboard.id);
    }
    this.props.dispatch(setDashboardSelectedItem(selectedDashboards));
  };

  render() {
    let { fetched, fetching, associationDashboard } = this.props;

    const { disabled } = this.state;

    return (
      <div className={styles.actions}>
        {/*{dashboardsList.length > 0 && (*/}
        {/*  <div*/}
        {/*    className={`${styles.select_all} ${*/}
        {/*      selectedDashboards.length > 0 ? styles.select_all_active : ""*/}
        {/*    }`}*/}
        {/*  >*/}
        {/*    <CheckBox*/}
        {/*      state={*/}
        {/*        selectedDashboards.length === dashboardsList.length*/}
        {/*          ? CHECKBOX_CHECKED*/}
        {/*          : selectedDashboards.length > 0*/}
        {/*            ? CHECKBOX_INDETERMINATE*/}
        {/*            : CHECKBOX_UNCHECKED*/}
        {/*      }*/}
        {/*      handleSelectCheckbox={this.handleSelectAllDashboard}*/}
        {/*    />*/}
        {/*    {_("selectAll")}*/}
        {/*  </div>*/}
        {/*)}*/}
        <TTPModal
          title={_("associateClientTitle")}
          visible={this.state.showAssociationModal}
          loading={false}
          handleOk={this.handleOk}
          handleCancel={this.handleCancelAssociationModal}
          width={800}
          footer={[
            <Button
              key="back"
              style={{ float: "left" }}
              onClick={this.handleCancelAssociationModal}
            >
              {_("cancel")}
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={this.state.loading}
              onClick={this.handleSubmitAssociationModal}
              disabled={disabled}
            >
              {_("save")}
            </Button>
          ]}
        >
          <div>
            <div className={styles.description}>{_("dashboardPrincipal")}:</div>
            <div className={styles.div_elements}>
              {fetching && <DashboardListFetching />}
              {fetched &&
                associationDashboard.map((dashboard, i) => {
                  return (
                    <div
                      key={i}
                      className={styles.element + " " + styles.element_dasboard}
                    >
                      <CheckBox
                        state={dashboard.state}
                        handleSelectCheckbox={() =>
                          this.handleSelectPrincipalDashboard(dashboard.id)
                        }
                      />
                      {dashboard.name}
                    </div>
                  );
                })}
            </div>
          </div>
        </TTPModal>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.dashboardList.fetching,
  fetched: state.dashboardList.fetched,
  associationDashboard: state.organizations.associationDashboard.data,
  selectedDashboards: state.dashboardList.selected,
  dashboardsList: state.dashboardList.items
});

export default connect(mapStateToProps)(DashboardActions);



// WEBPACK FOOTER //
// ./src/components/DashboardList/DashboardActions.js